import { AthosCollectionProvider } from '../fetchers/collection'
import { BeaconAnalyticsProvider } from '../hooks/useBeaconAnalytics'

import { CarouselResults } from './CarouselResults'

export function CarouselCollection({ handle, itemClass, controlClass, toggleControls, productLimit }) {
  // Convert productLimit to number if it's a string (from HTML attribute)
  const limit = productLimit ? parseInt(productLimit, 10) : 20

  // Request extra products to account for potential indexing issues
  const adjustedLimit = limit + 3

  return (
    <AthosCollectionProvider handle={handle} resultsPerPage={adjustedLimit}>
      <BeaconAnalyticsProvider type="category">
        <CarouselResults
          className={itemClass}
          hideControlsOnMobile={true}
          controlClass={controlClass}
          toggleControls={toggleControls}
          maxResults={limit}
        />
      </BeaconAnalyticsProvider>
    </AthosCollectionProvider>
  )
}
